<template>
    <div>
        <vs-row>
            <vs-col vs-lg="8" vs-sm="12" class="p-2">
                <vs-card class="content_mb_0 mb-0">
                    <div slot="header">
                        <h4>Class Curriculum</h4>
                    </div>
                    <div>
                        <div class="flex flex-wrap justify-between items-center mb-4">
                            <div class="inline-flex flex-wrap">
                                <img src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                                <span class="px-2">Alias Danos (You)</span>
                                <span class="cstm_badge primary">Online</span>
                            </div>
                            <h4>
                                <strong>July 7th, 2022</strong>
                            </h4>
                        </div>

                        <vs-tabs class="normal_tab">
                            <vs-tab label="Subjects">
                                <Subjects />
                            </vs-tab>

                            <vs-tab label="Coursework">
                                <Coursework />
                            </vs-tab>

                            <vs-tab label="Exams">
                                <Exams />
                            </vs-tab>
                        </vs-tabs>
                    </div>
                </vs-card>
            </vs-col>
            <vs-col vs-lg="4" vs-sm="12" class="p-2">
                <vs-card class="content_nb_0 mb-4">
                    <div slot="header">
                        <h4>Reports</h4>
                    </div>
                    <div class="text-center">
                        <i class="text-muted">No Recent Reports</i>
                    </div>
                </vs-card>
            </vs-col>

            <vs-col vs-w="12" class="p-2">
                <vs-card class="content_mb_0 mb-0">
                    <div slot="header" class="flex flex-wrap justify-between items-center">
                        <h5>Files</h5>
                        <div>
                            <a style="cursor: pointer;" class="inline-flex items-center mr-4">
                                <span style="font-size: 14px;" class="material-icons-outlined">file_download</span>
                                <span class="pl-1">Download all</span>
                            </a>
                        </div>
                    </div>
                </vs-card>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import Subjects from './subjects.vue'
import Coursework from './coursework.vue'
import Exams from './exams.vue'

export default {
  components: {
    Subjects,
    Coursework,
    Exams
  }
}
</script>